import { Colors, Lightning, Router } from '@lightningjs/sdk';
import SidebarItems, { sidebarLinks } from './SidebarItems/index.js';
import { Column } from '@lightningjs/ui-components';
import SidebarItem from './SidebarItems/SidebarItem.js';

export default class Sidebar extends Lightning.Component {
  static _template() {
    return {
      collision: true,
      zIndex: 101,
      x: 0,
      y: 0,
      w: 150,
      h: 1080,
      rect: true,
      zIndex: 100,
      color: Colors('#2e2e2e').get(),
      clipping: true,
      Border: {
        x: 147,
        y: 0,
        w: 3,
        h: 1080,
        rect: true,
        color: Colors('#02AC25').get(),
      },
      Items: {
        Column: {
          x: 60,
          w: 240,
          type: Column,
          collision: true,
          plinko: true,
          style: { itemSpacing: 0 },
          items: sidebarLinks.map((item, index) => ({
            collision: true,
            zIndex: 102,
            type: SidebarItem,
            index,
            plinko: true,
            h: 100,
            // flex: { direction: 'row', justifyContent: 'center', alignItems: 'center' },
            color: Colors('#FFFFFF').get(),
            item,
          })),
        },
        collision: true,
        h: 1080,
        w: 150,
        zIndex: 102,
        y: 200,
      },
    };
  }

  get _Column() {
    return this.tag('Items.Column');
  }

  _enable() {
    this.smooth = { alpha: 0.9 };
  }
  _checkActivePage() {
    const activePage = Router.getActiveHash();
    sidebarLinks.map((item, index) => {
      if (activePage === item.path) {
        this.tag('Items.Column').selectedIndex = index;
        return;
      }
    });
  }

  _focus() {
    this._checkActivePage();
    super._focus();
    this.smooth = { w: 300 };
    this.tag('Border').smooth = { x: 297 };
    this.fireAncestors('$itemChanged');
  }

  _unfocus() {
    super._unfocus();
    this.tag('Border').smooth = { x: 147 };
    this.smooth = { w: 150 };
  }

  _handleHover() {
    if (!Router.isNavigating()) {
      Router.focusWidget('sidebar');
      this._focus();
    }
  }

  _handleUnhover() {
    if (!Router.isNavigating()) {
      Router.focusPage();
      this._unfocus();
    }
  }

  $setIndex(index) {
    setTimeout(() => {
      this.tag('Items.Column').selectedIndex = index;
    }, 1);
  }

  _handleLeft() {
    return true;
  }

  _handleUp() {
    return true;
  }

  _handleDown() {
    return true;
  }

  _getFocused() {
    return this.tag('Items.Column');
  }
}
